import React from "react";
import { observer } from "mobx-react";
import { PageLayout } from "../../../../common/layout";
import { useRootStore } from "../../../../store/contexts";
import { WorkerEventView } from "./WorkerEventView";
import { WorkerEventViewStore } from "../../store/WorkerEventViewStore";
import { useStore } from "../../../../hooks";

export const WorkerEventViewPage = observer(() => {
  const rootStore = useRootStore();
  const { router } = rootStore;

  const id = router.params?.id as string;
  const path = `/workerEvent/view/${id}`;

  const store = useStore(
    path,
    () => {
      const s = new WorkerEventViewStore(rootStore);
      return s;
    },
    { id }
  );

  return (
    <div>
      <PageLayout
        navigationElements={{
          links: [],
          onNavigatedTo: (id) => {
            store.setCardState(id, true);
          },
        }}
      >
        <WorkerEventView workerEventViewStore={store} />
      </PageLayout>
    </div>
  );
});
